import React from "react";
import cn from "classnames";

import type { TDefaultLink } from "../../settings";
import { useUIKitContext } from "../../settings";

import styles from "./StyledLink.module.scss";

const DefaultLink = (props: TDefaultLink) => {
  return <a {...props} />;
};

export const useLink = () => {
  const { linkComponent } = useUIKitContext();
  if (typeof linkComponent === "undefined") {
    return { LinkComponent: DefaultLink };
  }
  return { LinkComponent: linkComponent };
};

export const Link = ({ e2eId, ...props }: TDefaultLink) => {
  const { LinkComponent } = useLink();
  return <LinkComponent data-testid={e2eId} {...props} />;
};

export const StyledLink = ({ className, ...props }: TDefaultLink) => {
  return <Link {...props} className={cn(styles.link, className)} />;
};
